module.exports = __webpack_public_path__ + "img/01.625cee06.png";